<div>
  <button mat-button (click)="onEditClick()" class="reddi-round-edit-button">
    <div class="reddi-edit-btn-text">
      <mat-icon class="reddi-edit-button-icon"> edit </mat-icon>
      Edit
    </div>
  </button>
</div>
